import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Building } from "../../../generated/types";
import { Button } from "../../common/Button";
import { ContextSummary } from "../../common/ContextSummary";
import { Modal, ModalActions } from "../../common/Modal";
import { sectionToIcon } from "../../type/default";
import { UnattachedDevices } from "../device/UnattachedDevices";
import { AssociateDeviceForm } from "../setup/AssociateDeviceForm";

/**
 * Ajout d'un produit à un bâtiment depuis son ticket admin / PSC : rattacher un produit de
 * l'entreprise encore sans bâtiment, ou associer un produit libre directement dans ce
 * bâtiment.
 */
export const AddDeviceToBuildingModal = ({
  building,
  breedingName,
  companyId,
  companyName,
  onClose,
}: {
  building: Building;
  breedingName: string;
  companyId: number;
  companyName: string;
  /** Appelé aussi après un ajout : le parent rafraîchit le ticket à la fermeture. */
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const [associated, setAssociated] = useState<string[]>([]);

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={t("building-add-device")}
      icon={sectionToIcon.section_device}
      maxWidth="md"
    >
      <div className="space-y-4">
        <ContextSummary
          rows={[
            { label: t("device-attach-building-label"), value: building.name },
            { label: t("building-create-for-breeding"), value: breedingName },
            { label: t("breeding-create-for-company"), value: companyName },
          ]}
        />
        <UnattachedDevices companyId={companyId} buildings={[building]} />
        <AssociateDeviceForm
          companyId={companyId}
          buildings={[building]}
          initialBuildingId={String(building.id)}
          associated={associated}
          onAssociated={(uuid) => setAssociated((prev) => [...prev, uuid])}
        />
        <ModalActions>
          <Button type="button" onClick={onClose}>
            {t("button-close")}
          </Button>
        </ModalActions>
      </div>
    </Modal>
  );
};
